exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#account[data-v-57c2d52c] {\n    margin: 12px;\n    margin-top: 36px;\n.top[data-v-57c2d52c] {\n        margin-bottom: 12px;\n}\n.account[data-v-57c2d52c] {\n.segment[data-v-57c2d52c] {\n&[data-v-57c2d52c]:hover {\n                background-color: #f5f5f5;\n                cursor: pointer;\n}\n}\n.column[data-v-57c2d52c] {\n            font-size: large;\n.main[data-v-57c2d52c] {\n                font-weight: bold;\n                margin-top: 6px;\ni.icon[data-v-57c2d52c] {\n                    margin-right: 20px;\n}\n}\n}\n}\n}\n", ""]);

// exports
